/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The AutomationtriggersactionsData model module.
 * @module model/AutomationtriggersactionsData
 * @version 1.0.0
 */
export class AutomationtriggersactionsData {
  /**
   * Constructs a new <code>AutomationtriggersactionsData</code>.
   * @alias module:model/AutomationtriggersactionsData
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AutomationtriggersactionsData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AutomationtriggersactionsData} obj Optional instance to populate.
   * @return {module:model/AutomationtriggersactionsData} The populated <code>AutomationtriggersactionsData</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AutomationtriggersactionsData();
      if (data.hasOwnProperty('data'))
        obj.data = ApiClient.convertToType(data['data'], 'String');
      if (data.hasOwnProperty('schedule'))
        obj.schedule = ApiClient.convertToType(data['schedule'], 'String');
      if (data.hasOwnProperty('nextDate'))
        obj.nextDate = ApiClient.convertToType(data['nextDate'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} data
 */
AutomationtriggersactionsData.prototype.data = undefined;

/**
 * @member {String} schedule
 */
AutomationtriggersactionsData.prototype.schedule = undefined;

/**
 * @member {String} nextDate
 */
AutomationtriggersactionsData.prototype.nextDate = undefined;

